<template>
  <b-modal :id="id" :cancel-title="$t('_cancel')" ref="resend_email" @ok="ok" :modal-class="modalClass" :title="$t(title)"
  >
    <frontoffice-loader v-if="isLoading && !displayError" />

    <text-input v-else :required="true" :name="id" type="email" v-model="email"
                :label="$t(label)" :placeholder="$t(placeholder)"
    />

    <b-alert v-if="displayError" variant="danger" show class="col-12">
      {{ errorMessage }}
    </b-alert>
  </b-modal>
</template>

<script>
import textInput from "@/components/frontoffice/form/baseInput/text"
import frontofficeLoader from '@/components/frontoffice/loader'
import FormSubmitter from '@/api/formSubmitter'
import loadingModalMixin from'@/components/frontoffice/mixins/loadingModal'

export default {
  components: {
    textInput,
    frontofficeLoader
  },

  mixins: [loadingModalMixin],

  props: {
    id: {
      type: String,
      default: 'resend_email'
    }
  },

  data () {
    return {
      isLoading: false,
      email: '',
      displayError: false,
      errorMessage: null,
      closeAfterServerResponse: true,
      title: 'maillog.resendEmail.title',
      label: 'maillog.resendEmail.label',
      placeholder: 'maillog.resendEmail.placeholder'
    }
  },

  methods: {
    ok (event) {
      event.preventDefault()
      this.isLoading = true
      this.displayError = false

      if (!this.email) {
        this.setErrorMessage('maillog.resendEmail.noEmail')
      } else {
        this.confirm()
      }
    },

    confirm () {
      let submitter = new FormSubmitter('resend_email')

      submitter.submitRequest({email: this.email}, this.$route.params.id)
        .then(response => {
          if (response.data.success) {
            this.dealSuccess()
          } else {
            this.dealFailure(response.data.errors)
          }
        })
    },

    dealSuccess () {
      this.$emit('ok', this.successMessage)
      this.$bvModal.hide(this.id)
      this.reset()
    },

    dealFailure (errors) {
      this.setErrorMessage(errors[0])
    },

    setErrorMessage (msg) {
      this.displayError = true
      this.isLoading = false
      this.errorMessage = this.$te(`error.${msg}`)
        ? this.$t(`error.${msg}`)
        : this.$te(msg)
        ? this.$t(msg)
        : this.$t('maillog.resendEmail.error')
    },

    reset () {
      this.email = ''
      this.isLoading = false
      this.displayError = false
    }
  },

  computed: {
    successMessage () {
      if (this.email.includes(';')) {
        this.email = this.email.replace(/;/gi, ',')
        this.email = this.email.replace(/\s+/gi, ' ')
        let i = this.email.lastIndexOf(',')
        let rep = this.$t('_and')
        this.email = this.email.substring(0, i) + rep + this.email.substring(i + 1)
      }

      return this.$t('maillog.resendEmail.success', {email: this.email})
    }
  },

  watch: {
    isLoading (val) {
      this.title = val ? '' : 'maillog.resendEmail.title'
    }
  }
}
</script>
